import React, { lazy, useEffect, useRef, Suspense } from 'react'
import { BrowserRouter as Router, Switch, Redirect, Route, useLocation } from 'react-router-dom'
import AccessibleNavigationAnnouncer from './components/AccessibleNavigationAnnouncer'
import ProtectedRoute from './components/Routes/ProtectedRoute'
import ForwardRoute from './components/Routes/ForwardRoute'
import { GamificationProvider } from './context/GamificationContext'
import { FeatureHighlightProvider } from './context/FeatureHighlightContext'
import XpGainNotification from './components/Gamification/XpGainNotification'
import AchievementToast from './components/Gamification/AchievementToast'
import SimpleToast from './components/Gamification/SimpleToast'
import './assets/css/toast-notifications.css'
import './assets/css/feature-highlight.css'
import './assets/css/premium.css'
import './assets/css/revamp.css'

const Layout = lazy(() => import('./containers/Layout'))
const Auth = lazy(() => import('./containers/Auth'))
const UnverifiedEmail = lazy(() => import('./pages/UnverifiedEmail'))
const EmailVerification = lazy(() => import('./pages/EmailVerification'))
const Preview = lazy(() => import('./pages/Preview'))

// Meta PageView on in-app navigation. The first page view fires in public/index.html.
function MetaPageView() {
  const { pathname } = useLocation()
  const first = useRef(true)
  useEffect(() => {
    if (first.current) { first.current = false; return }
    if (typeof window.fbq === 'function') window.fbq('track', 'PageView')
  }, [pathname])
  return null
}

function App() {
  useEffect(() => {
    // Sendinblue tracking script
    const sibScript = document.createElement('script');
    sibScript.type = 'text/javascript';
    sibScript.async = true;
    sibScript.innerHTML = `
      (function() {
          window.sib = {
              equeue: [],
              client_key: "1mu4ff71i7d66ptttdubnmwo"
          };
          window.sendinblue = {};
          for (var j = ['track', 'identify', 'trackLink', 'page'], i = 0; i < j.length; i++) {
          (function(k) {
              window.sendinblue[k] = function() {
                  var arg = Array.prototype.slice.call(arguments);
                  (window.sib[k] || function() {
                          var t = {};
                          t[k] = arg;
                          window.sib.equeue.push(t);
                      })(arg[0], arg[1], arg[2], arg[3]);
                  };
              })(j[i]);
          }
          var n = document.createElement("script"),
              i = document.getElementsByTagName("script")[0];
          n.type = "text/javascript", n.id = "sendinblue-js", n.async = !0, n.src = "https://sibautomation.com/sa.js?key=" + window.sib.client_key, i.parentNode.insertBefore(n, i), window.sendinblue.page();
      })();
    `;
    document.body.appendChild(sibScript);

    return () => {
      document.body.removeChild(sibScript);
    };
  }, []);

  return (
    <>
      <Router>
        <AccessibleNavigationAnnouncer />
        <MetaPageView />
        <Suspense fallback={<div>Loading...</div>}>
          <GamificationProvider>
            <FeatureHighlightProvider>
              <Switch>
                <ForwardRoute path="/auth" component={Auth} />
                <ProtectedRoute path="/app" component={Layout} />
                <Route exact path="/unverified-email" component={UnverifiedEmail} />
                <Route exact path="/verify-email" component={EmailVerification} />
                <Route exact path="/preview" component={Preview} />
                <Redirect from="*" to="/app" />
              </Switch>
              
              {/* Gamification UI elements */}
              <div className="toast-container">
                <XpGainNotification />
                <AchievementToast />
                <SimpleToast />
              </div>
            </FeatureHighlightProvider>
          </GamificationProvider>
        </Suspense>
      </Router>
    </>
  )
}

export default App;
